// extracted by mini-css-extract-plugin
module.exports = {"photosTypes":"PhotosTypes_photosTypes__39lyB","photoType":"PhotosTypes_photoType__UBnuT","extra":"PhotosTypes_extra__NUpFm"};